import{a as e}from"./chunk-ERXYZXKF.js";import{m as n}from"./chunk-HBP5N4FR.js";n();var T=({address:s,token:o,signature:t})=>{let r=e(s),c=e(o);return`${r}.${c}.${t}`};export{T as a};
//# sourceMappingURL=chunk-JZAKIB2G.js.map
